import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "navBarContainer relative z-10" }
const _hoisted_2 = { class: "top flex items-center justify-between h-14 border-b" }
const _hoisted_3 = { class: "start flex gap-4 items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 md:h-10",
    src: "/img/logo_dorado.svg",
    alt: "Logo"
  })
], -1)
const _hoisted_5 = { class: "center w-1/2 hidden md:block" }
const _hoisted_6 = {
  id: "cart",
  class: "relative flex gap-2 text-sm text-emerald-900"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Tu carrito", -1)
const _hoisted_8 = { class: "flex absolute -top-1 -right-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "animate-ping absolute inline-flex h-4 w-4 rounded-full bg-emerald-900 opacity-75" }, null, -1)
const _hoisted_10 = { class: "relative inline-flex rounded-full h-4 w-4 bg-emerald-900 items-center justify-center" }
const _hoisted_11 = { class: "text-xs text-white" }
const _hoisted_12 = { class: "bottom h-8 border-b gap-6 items-center justify-center hidden md:flex" }
const _hoisted_13 = { class: "text-sm font-semibold uppercase text-emerald-900" }
const _hoisted_14 = { class: "sideBarHeader p-4 flex items-center justify-between" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, "MENU", -1)
const _hoisted_16 = { class: "sideBarBody flex flex-col px-4" }
const _hoisted_17 = { class: "sideBarOption py-4 flex gap-2 items-center border-b" }
const _hoisted_18 = { class: "text-emerald-900 font-semibold uppercase" }
const _hoisted_19 = { class: "mainContainer min-h-screen overflow-hidden" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "footer bg-emerald-900 p-8 flex gap-y-12 items-center justify-between flex-wrap md:flex-nowrap" }
const _hoisted_22 = { class: "logo space-y-8 w-full md:w-auto" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-12 mx-auto mb-8",
  src: "/img/logo_dorado.svg",
  alt: "Logo"
}, null, -1)
const _hoisted_24 = { href: "https://goo.gl/maps/bCpiKyFTMmcUkns7A" }
const _hoisted_25 = { class: "address text-xs text-white flex gap-2 justify-center md:justify-start" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text text-center md:text-left" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Sgto Penayo c/ Blanislava Sunik"),
  /*#__PURE__*/_createElementVNode("p", null, "San Lorenzo, Asunción.")
], -1)
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"links space-y-4 text-sm hidden md:block\"><p class=\"font-semibold text-[#CC9F53] border-b-2 border-[#CC9F53] inline pr-2\">Links</p><div class=\"options text-white text-xs flex flex-col gap-2\"><a href=\"/#inicio\"><p>Inicio</p></a><a href=\"/sale\"><p>Ofertas</p></a><a href=\"/about-us\"><p>Sobre nosotros</p></a></div></div>", 1)
const _hoisted_28 = { class: "links space-y-4 text-sm hidden md:block" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-[#CC9F53] border-b-2 border-[#CC9F53] inline pr-2" }, "Contacto", -1)
const _hoisted_30 = { class: "options text-white text-xs flex flex-col gap-2" }
const _hoisted_31 = ["href"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "Facebook", -1)
const _hoisted_33 = ["href"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, "Instagram", -1)
const _hoisted_35 = ["href"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, "Whatsapp", -1)
const _hoisted_37 = ["href"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "Email", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-2 items-center text-white align-self-center w-full md:w-auto text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "Desarrollado por"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://adro.studio",
    class: "text-xl opacity-50"
  }, "adro.studio")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_MenuDropdown = _resolveComponent("MenuDropdown")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBar, { class: "bg-white" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "sideBarButton w-6 h-6 md:hidden",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSideBar()))
              }, [
                _createVNode(_component_Icon, {
                  iconImg: "/img/icons/menu.svg",
                  color: "bg-[#CC9F53]"
                })
              ]),
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SearchBar)
            ]),
            _createVNode(_component_router_link, { to: "/cart" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_Icon, {
                    iconImg: "/img/icons/shopping-cart.svg",
                    color: "bg-emerald-900"
                  }),
                  _withDirectives(_createElementVNode("span", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$store.state.order.products.length), 1)
                    ])
                  ], 512), [
                    [_vShow, _ctx.$store.state.order.products.length > 0]
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuOptions, (menuOption, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "menuOption",
              key: index
            }, [
              (menuOption.suboptions && menuOption.suboptions.length > 0)
                ? (_openBlock(), _createBlock(_component_MenuDropdown, {
                    key: 0,
                    class: "text-sm border-y-2 border-transparent hover:border-b-[#CC9F53] py-1 px-2",
                    text: menuOption.text,
                    icon: menuOption.icon,
                    options: menuOption.suboptions,
                    mode: "floating"
                  }, null, 8, ["text", "icon", "options"]))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: menuOption.link,
                    class: "flex gap-2 items-center border-y-2 border-transparent hover:border-b-[#CC9F53] py-1 px-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        iconImg: menuOption.icon,
                        color: "bg-emerald-900"
                      }, null, 8, ["iconImg"]),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(menuOption.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_SideBar, { isOpen: _ctx.sideBarOpen }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", {
            class: "closeIcon w-6 h-6 flex-none bg-black",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSideBar())),
            style: {"mask-image":"url('/img/icons/x.svg')","mask-position":"center","mask-size":"cover"}
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuOptions, (menuOption, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "menuOption",
              key: index
            }, [
              (menuOption.suboptions && menuOption.suboptions.length > 0)
                ? (_openBlock(), _createBlock(_component_MenuDropdown, {
                    key: 0,
                    class: "sideBarOption py-4 font-semibold border-b",
                    text: menuOption.text,
                    icon: menuOption.icon,
                    options: menuOption.suboptions,
                    onOptionClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSideBar()))
                  }, null, 8, ["text", "icon", "options"]))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: menuOption.link,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSideBar()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_Icon, {
                          iconImg: menuOption.icon,
                          color: "bg-emerald-900"
                        }, null, 8, ["iconImg"]),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(menuOption.text), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createElementVNode("main", _hoisted_19, [
      (_openBlock(), _createBlock(_component_router_view, {
        key: _ctx.$route.path
      }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ], 1024))
        ]),
        _: 1
      }))
    ]),
    (_ctx.config.whatsapp_nbr)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "fixed bottom-4 right-4 bg-green-900 p-4 z-10 rounded-full shadow-lg",
          href: 'https://wa.me/' + _ctx.config.whatsapp_nbr,
          target: "_blank",
          "data-aos": "fade-left",
          "data-aos-anchor-placement": "top",
          "data-aos-delay": "2000"
        }, [
          _createVNode(_component_Icon, {
            iconImg: "/img/icons/whatsapp.svg",
            color: "bg-white"
          })
        ], 8, _hoisted_20))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("a", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_Icon, {
              iconImg: "/img/icons/location-marker.svg",
              color: "bg-[#CC9F53]"
            }),
            _hoisted_26
          ])
        ])
      ]),
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          (_ctx.config.facebook_link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "option flex gap-2 items-center",
                href: _ctx.config.facebook_link
              }, [
                _createVNode(_component_Icon, {
                  iconImg: "/img/icons/facebook.svg",
                  color: "bg-[#CC9F53]"
                }),
                _hoisted_32
              ], 8, _hoisted_31))
            : _createCommentVNode("", true),
          (_ctx.config.instagram_link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "option flex gap-2 items-center",
                href: _ctx.config.instagram_link
              }, [
                _createVNode(_component_Icon, {
                  iconImg: "/img/icons/instagram.svg",
                  color: "bg-[#CC9F53]"
                }),
                _hoisted_34
              ], 8, _hoisted_33))
            : _createCommentVNode("", true),
          (_ctx.config.whatsapp_nbr)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                class: "option flex gap-2 items-center",
                href: 'https://wa.me/' + _ctx.config.whatsapp_nbr
              }, [
                _createVNode(_component_Icon, {
                  iconImg: "/img/icons/whatsapp.svg",
                  color: "bg-[#CC9F53]"
                }),
                _hoisted_36
              ], 8, _hoisted_35))
            : _createCommentVNode("", true),
          (_ctx.config.email)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                class: "option flex gap-2 items-center",
                href: 'mailto:' + _ctx.config.email
              }, [
                _createVNode(_component_Icon, {
                  iconImg: "/img/icons/mail.svg",
                  color: "bg-[#CC9F53]"
                }),
                _hoisted_38
              ], 8, _hoisted_37))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_39
    ])
  ], 64))
}